module.exports = __webpack_public_path__ + "img/g_wenran.2bb45fa4.png";